import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    this.params = new URLSearchParams(window.location.search.substring(1))

    // Helper: finde alle Keys wie "region[0]" / "region[something]"
    const indexedKeysFor = (base, params) => {
      const keys = []
      for (const key of params.keys()) {
        if (key.startsWith(base + '[') && key.endsWith(']')) keys.push(key)
      }
      return keys
    }

    Array.from(this.element.querySelectorAll('button:not(.disabled)')).forEach(btn => {
      btn.addEventListener('pointerdown', () => {
        const name = btn.dataset.name
        const value = btn.dataset.value?.toString()

        if (this.params.has(name)) {
          // einfacher Key: ?name=...
          if (this.params.get(name).includes(',')) {
            // CSV-Werte
            if (value) {
              const vals = this.params.get(name).split(',')
              const idx = vals.indexOf(value)
              if (idx !== -1) {
                vals.splice(idx, 1)
                vals.length ? this.params.set(name, vals.join(',')) : this.params.delete(name)
              } else {
                // nichts zu entfernen -> lösche komplett oder ignoriere
                this.params.delete(name)
              }
            } else {
              this.params.delete(name)
            }
          } else {
            // Single-Value
            value ? this.params.set(name, value) : this.params.delete(name)
          }
        } else if (this.params.has(name + '[]')) {
          // PHP-Style: ?name[]=a&name[]=b
          const arrName = name + '[]'
          const all = this.params.getAll(arrName)
          if (value) {
            // Alle Vorkommen mit diesem Wert entfernen
            for (const v of all) {
              if (v === value) this.params.delete(arrName)
            }
            // Übrig gebliebene Werte wieder anhängen
            // (delete entfernt alle; also neu aufbauen)
            for (const v of all.filter(v => v !== value)) {
              this.params.append(arrName, v)
            }
          } else {
            this.params.delete(arrName)
          }
        } else {
          // **NEU**: indexierte Keys wie ?region[0]=10&region[1]=26
          const keys = indexedKeysFor(name, this.params) // ['region[0]', 'region[1]', ...]
          if (keys.length) {
            if (value) {
              // nur den Eintrag mit passendem Wert entfernen
              for (const key of keys) {
                if (this.params.get(key) === value) this.params.delete(key)
              }
            } else {
              // alle indexierten Einträge entfernen
              for (const key of keys) this.params.delete(key)
            }
          }
        }

        window.location = window.location.pathname + '?' + this.params.toString()
      })
    })
  }
}